import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import LinearProgress from "@material-ui/core/LinearProgress";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {FONTS, PRIMARY_COLOR, SECONDARY_COLOR} from "../../constants";
import {addAlpha} from "../../helpers/DataHelpers";
import {stateType} from "../../state";
import {BoxHeader} from "./BoxHeader";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			width: "100%",
			"& > * + *": {
				marginTop: theme.spacing(2),
			},
		},
		colorPrimary: {
			backgroundColor: addAlpha(SECONDARY_COLOR, 0.2),
		},
		barColorPrimary: {
			backgroundColor: SECONDARY_COLOR,
		},
		progressDisabled: {
			backgroundColor: addAlpha(PRIMARY_COLOR, 0.2),
		},
	})
);

function LinearIndeterminate() {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<LinearProgress />
			<LinearProgress color="secondary" />
		</div>
	);
}

export function ProgressBar({progress, isDisabled}) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<LinearProgress
				// variant="determinate"
				// value={progress}
				classes={{
					colorPrimary: isDisabled
						? classes.progressDisabled
						: classes.colorPrimary,
					barColorPrimary: classes.barColorPrimary,
				}}
				style={{height: "10px", borderRadius: "10px"}}
			/>
		</div>
	);
}

export function LoadingDialog({state}: stateType) {
	return (
		<Dialog
			open={state.isLoadingPopupOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth="lg"
			style={{marginTop: "-300px"}}
		>
			<DialogContent style={{overflow: "hidden"}}>
				<div
					style={{
						width: "400px",
						marginTop: "-30px",
						marginLeft: "-30px",
						marginRight: "-30px",
					}}
				>
					<BoxHeader
						title={"Loading..."}
						toolTip={""}
						showTip={false}
					></BoxHeader>
				</div>
				<div
					style={{
						fontFamily: FONTS,
						fontSize: "14px",
						marginBottom: "10px",
						marginTop: "20px",
					}}
				>
					Analyzing your dataset...
				</div>
				<div style={{marginBottom: "30px"}}>
					<ProgressBar progress={50} isDisabled={false}></ProgressBar>
				</div>
			</DialogContent>
		</Dialog>
	);
}
